/**
 * Feature flags de presença / recusa — default = comportamento atual (false).
 * Testes: setPresenceTtlEnforcedForTests / setDeclineAcceleratesTierForTests.
 */

let presenceTtlOverride: boolean | null = null;
let declineAccelOverride: boolean | null = null;

export function setPresenceTtlEnforcedForTests(value: boolean | null): void {
  presenceTtlOverride = value;
}

export function setDeclineAcceleratesTierForTests(value: boolean | null): void {
  declineAccelOverride = value;
}

function readEnvTrue(name: string): boolean {
  try {
    if (typeof process !== 'undefined' && process.env?.[name] === 'true') return true;
  } catch {
    /* ignore */
  }
  try {
    // @ts-expect-error import.meta.env só no Vite
    if (typeof import.meta !== 'undefined' && import.meta.env?.[`VITE_${name}`] === 'true') {
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

/** Default false — TTL não altera nada até José ligar. */
export function readPresenceTtlEnforced(): boolean {
  if (presenceTtlOverride !== null) return presenceTtlOverride;
  return readEnvTrue('PRESENCE_TTL_ENFORCED');
}

/** Default false — recusa continua só UI até José ligar. */
export function readDeclineAcceleratesTier(): boolean {
  if (declineAccelOverride !== null) return declineAccelOverride;
  return readEnvTrue('DECLINE_ACCELERATES_TIER');
}
